import type { ReactNode } from 'react';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import Login from 'src/features/authentication/Login';
import Page404 from 'src/features/errors/Page404';

interface MfaSetGuardProps {
  children: ReactNode;
}

/**
 * MFA方法設定用 一時Guard
 *  - ユーザーがID／Passwordによる1次ログインを完了していれば、2次ログイン(MFA認証)が未完了でも遷移可能とする
 * @param Props MfaSetGuardProps
 * @return MfaSetGuard
 */
const MfaSetGuard = ({ children }: MfaSetGuardProps) => {
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);
  // 1次ログイン(ID/Password認証)未完了の場合
  if (!auth.isAuthenticated) {
    // 画面遷移不可・ログイン画面へ戻る
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <Login />;
  }

  // フェデレーション認証時は遷移不可
  if (auth.user?.identities) {
    return <Page404 />;
  }

  // 画面遷移
  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }
  return <>{children}</>;
};

MfaSetGuard.propTypes = {
  children: PropTypes.node,
};

export default MfaSetGuard;
